module.exports = __webpack_public_path__ + "static/media/correct9.1730d813.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/correct9.svg
// module id = 546
// module chunks = 0